import LoginModal from '../modals/LoginModal';
import FullscreenGaleryCarouselModal from '../modals/FullscreenGaleryCarouselModal';
import GalleryCarouselModal from '../modals/GalleryCarouselModal';
import AjaxFormModal from '../modals/AjaxFormModal';
import AjaxModal from '../modals/AjaxModal';
import CallBackAjaxForm from '../forms/CallBackAjaxForm';
import ContactAjaxForm from '../forms/ContactAjaxForm';

const modalFactory = (type, data) => {
  switch (type) {
    case 'login':
      return new LoginModal(data.url);
    case 'fullscreen-gallery':
      return new FullscreenGaleryCarouselModal(data.url);
    case 'window-gallery':
      return new GalleryCarouselModal(data.url);
    case 'form':
      return new AjaxFormModal(data.url);
    case 'ajax':
      return new AjaxModal(data.url);
    case 'callback':
      return new AjaxFormModal(data.url, CallBackAjaxForm);
    case 'contact':
      return new AjaxFormModal(data.url, ContactAjaxForm);
    default:
      return null;
  }
};

export const linkModals = () => {
  document.querySelectorAll('.js-modal-open').forEach(trigger => {
    trigger.addEventListener('click', eventObj => {
      eventObj.preventDefault();
      eventObj.stopPropagation();
      const modalType = eventObj.currentTarget.getAttribute('data-modal-type');
      const data = {
        url: eventObj.currentTarget.getAttribute('data-url'),
      };
      const modal = modalFactory(modalType, data);
      if (modal) {
        modal.open();
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/js/modals/link_modals.js